/**
 * structureCallForHelp — When a champion damages an enemy champion,
 * structures may switch aggro to that attacker (LoL call-for-help).
 */

export function shouldRecordCallForHelp(attacker, victim) {
  if (!attacker || !victim) return false;
  if (attacker.isDead || victim.isDead) return false;
  if (attacker === victim) return false;
  if (attacker.team === victim.team) return false;
  if (attacker.type !== 'champion' || victim.type !== 'champion') return false;
  return true;
}

export function pushCallForHelpEvent(events, attacker, victim) {
  if (!Array.isArray(events)) return;
  if (!shouldRecordCallForHelp(attacker, victim)) return;
  events.push({ attacker, victim });
}
